var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreFunnelHomeContents',{attrs:{"choose-building-type-text":_vm._f("ScString")(_vm.fields.chooseBuildingTypeText),"link":_vm._f("ScLink")(_vm.fields.link),"building-types":_vm.buildingTypes}})
}
var staticRenderFns = []

export { render, staticRenderFns }